module.exports = __webpack_public_path__ + "img/edit.638b392b.svg";